var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.list.meta
    ? _c(
        "div",
        { staticClass: "website-list", class: _vm.list.meta.list_type },
        [
          _vm._l(_vm.list.data, function (item, key) {
            return [
              _c(_vm.list.component, {
                key: key,
                tag: "component",
                attrs: { item: item },
              }),
            ]
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }